<div class="flex flex-col h-screen bg-background px-4">
  <div class="flex flex-col gap-1 items-center justify-center py-2">
    <h1 class="text-2xl text-primary tracking-wide font-medium">
      Angular Forms Designer
    </h1>
    <p class="text-on-background">
      Create beautiful, responsive forms with Angular Material and Tailwind CSS
    </p>
  </div>

  <div>
    <mat-form-field>
      <mat-label>Select a Form</mat-label>
      <mat-select>
        <mat-option *ngFor="let form of formList" [value]="form.id">
          {{ form.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <p>You selected: {{ selected }}</p>
    <p>Form title: {{ formTitle }}</p>
  </div>

  <div
    class="flex gap-4 relative flex-1 overflow-visible pb-4"
    cdkDropListGroup
  >
    <button
      mat-flat-button
      color="primary"
      (click)="exportForm()"
      class="!absolute -top-[45px] right-0 compact-button z-50"
    >
      Export Form
      <mat-icon>download</mat-icon>
    </button>

    <button
      mat-flat-button
      color="primary"
      (click)="saveFormToBackend()"
      class="!absolute -top-[45px] right-40 compact-button z-50"
    >
      Save Form
      <mat-icon>cloud_upload</mat-icon>
    </button>

    <!-- <sw-form-element-menu class="w-64 bg-white rounded-md shadow-sm border border-gray-200">
    </sw-form-element-menu>
    
    <sw-main-canvas class="flex-1 bg-white rounded-md shadow-sm border border-gray-200 overflow-y-auto">
    </sw-main-canvas>
    
    <sw-field-settings class="w-80 bg-white rounded-md shadow-sm border border-gray-200">
    </sw-field-settings> -->

    <!-- Left: Form Elements -->
    <sw-form-element-menu
      class="w-64 shrink-0 bg-white rounded-md shadow-sm border border-gray-200 overflow-y-auto"
    >
    </sw-form-element-menu>

    <!-- Center: Main Canvas -->
    <sw-main-canvas
      class="flex-1 min-w-0 bg-white rounded-md shadow-sm border border-gray-200 overflow-y-auto"
    >
    </sw-main-canvas>

    <!-- Right: Field Settings -->
    <sw-field-settings
      class="w-80 shrink-0 bg-white rounded-md shadow-sm border border-gray-200 overflow-y-auto"
    >
    </sw-field-settings>
  </div>
</div>
